import axios from '@/xaxios' 
import { getApiFactura, FACTURAS_BASE_PATH } from './facturafacil';

export const send_email = async (email, cufe,unidad,sede) => {
  const myHeaders = new Headers();
  const apisdata = getApiFactura(unidad, sede);

  myHeaders.append('X-FF-Company', apisdata.X_FF_COMPANY);
  myHeaders.append('X-FF-Branch', apisdata.X_FF_BRANCH);
  myHeaders.append('X-FF-API-Key', apisdata.X_FF_API_KEY);
  myHeaders.append('Content-Type', 'application/json');

  const input = {
    email: email
  } 

  let apidev = process.env.VUE_APP_GRAPHQL;
  let TEST = apidev.includes("apidev")
  let url = `${FACTURAS_BASE_PATH}/proxy2/https://api.facturafacil.com.pa/api/pac/reception_fe/${cufe}/send_email/`
  if(TEST) url = `${FACTURAS_BASE_PATH}/proxy/api/pac/reception_fe/${cufe}/send_email/`

  
  return await axios.post(
  url,
  input,
    {
      headers: { 
        'X-FF-Company': apisdata.X_FF_COMPANY, 
        'X-FF-Branch': apisdata.X_FF_BRANCH,
        'X-FF-API-Key': apisdata.X_FF_API_KEY,
      }
    }
  ).then(({ data }) => data);

};
